import React from 'react';
import { useState, useEffect } from 'react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import MovieCard from '../Movies/MovieCard';
import DetailsFile from '../DetailsFile';
import MovieDetail from '../../container/Detail/MovieDetail';
import Home from '../../container/Home/Home';

function MovieCardSlide() {
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMovieCard = async () => {
      const url = 'https://api.themoviedb.org/3/movie/popular?api_key=2fa17ff7cae269858213010f9e657124';
      try {
        const res = await fetch(url);
        if (!res.ok) {
          throw new Error(`HTTP error ! ${res.status}`)
        }
        const data = await res.json();
        setMovies(data.results)
      } catch (error) {
        console.error('Error fetching Movies', error);
        setError(error)
      }
      finally {
        setLoading(false)
      }
    }
    fetchMovieCard()
  }, [])
  return (
    <Swiper
      // install Swiper modules
      modules={[Navigation, Scrollbar, A11y]}
      spaceBetween={16}
      slidesPerView={5}
      navigation
      scrollbar={{ draggable: true }}
      onSwiper={(swiper) => console.log(swiper)}
      onSlideChange={() => console.log('slide change')}
      breakpoints={{
        340: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        578: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
       
      }}
    >
      {loading ? (
        <p>Loading..</p>
      ) : (
        movies.map((movie, onClick) => (
          <SwiperSlide key={movie.id}>
            <div className="rounded h-full m-1 relative m-2">
              <MovieCard movie={movie} />
            </div>
          </SwiperSlide>
        ))
      )}
    </Swiper>
  )
}

export default MovieCardSlide